import React from "react";
import {Localizer} from "@/main/react/Types";
import {GroupLeadershipLevel} from "@/main/common/GroupGovernanceApi";

/**
 * Shared rendering for a member's leadership standing within a group
 * (Owner / Administrator / Moderator). Plain members have no leadership level and
 * intentionally render no chip — the chip is a signal of elevated standing.
 *
 * Lifted out of GroupPageSectionLists so the members list, user card, and discussion
 * author attribution all render the same pill.
 */

const LEADERSHIP_LEVELS: readonly GroupLeadershipLevel[] = ["OWNER", "ADMINISTRATOR", "MODERATOR"];

/** Narrow the raw string carried by the DTO to a known leadership level, or null for a plain member. */
export function toGroupLeadershipLevel(value?: string | null): GroupLeadershipLevel | null {
    return LEADERSHIP_LEVELS.includes(value as GroupLeadershipLevel) ? (value as GroupLeadershipLevel) : null;
}

export function getLeadershipLabel(localizer: Localizer, leadershipLevel?: GroupLeadershipLevel | null): string {
    switch (leadershipLevel) {
        case "OWNER":
            return localizer("group.leadership.owner");
        case "ADMINISTRATOR":
            return localizer("group.leadership.administrator");
        case "MODERATOR":
            return localizer("group.leadership.moderator");
        default:
            return localizer("group.leadership.member");
    }
}

export function GroupLeadershipBadge({ label }: { label: string }) {
    return (
        <span className="rounded-full border border-border bg-[var(--background1)] px-2.5 py-1 text-xs font-medium text-text-main">
            {label}
        </span>
    );
}
